import styled from 'styled-components'

const Title = styled.div`
    margin-bottom: 11px;
    font-size: 16px;
    line-height: 1.5;
    color: #151a43;
    margin-top: ${props => props.marginTop || '0px'};
`

const VerifyButton = styled.div`

    border: 2px solid transparent;
    border-radius: 28px;
    background-image: linear-gradient(white, white), 
                        linear-gradient(93deg, #ffec38 10%, #f7b500 96%);
    background-origin: border-box;
    background-clip: content-box, border-box;
    height: 49px;
    display: flex;
    justify-content: flex-start;
    margin-top: 4px;
    flex-wrap: wrap;
    align-items: center;
    color: #414670;
    font-size: 16px;
    width: ${props => props.width || '400px'};
    cursor: pointer;
    transition: all 0.4s ease-in-out;
    &:focus {
        outline: none;
    }
    &:hover{
        transform: scale(1.02) translateY(-4px);
        transition: all .2s ease-in-out;
    }
    &:visited{
        color: #414670;
    }
    & .SVGInline {
        margin-top: 5px;
        margin-left: 17px;
    }
`

const ButtonText = styled.span`
    font-family: Lato;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #2b2b2b;
    margin-left: 20px;
`

const ButtonContainer = styled.div `
    display: flex;
    align-items: center;
    vertical-align: middle;
    height: 100%;
    justify-content: center;
`

const OrContainer = styled.div`
    display: flex;
    align-items: center;
    color: #151a4340;
`

const HorizontalLine = styled.div`
    width: 92px;
    margin-top: 8px;
    border: solid 1px rgba(95, 101, 150, 0.16);
`

export const ErrorMessage = styled.p`
    font-size: 16px;
    width: 350px;
    text-align: center;
    color: rgba(65, 70, 112, 0.6);
    line-height: 1.6;
`
export const ErrorTitle = styled.h3`
    font-size: 22px;
    color: #2a3a74;
    line-height: 1.23;
    padding: 3px 0;
`
export const ErrorAction = styled.div`
    font-size: 16px;
    text-decoration: underline;
    color: #414670;
    cursor: pointer;
    padding-top: 20px;
`


export const DividerTextStyle = {
    'fontFamily': 'Lato',
    'fontSize': '28px',
    'fontWeight': 'normal',
    'fontStretch': 'normal',
    'fontStyle': 'normal',
    'lineHeight': 'normal',
    'letterSpacing': 'normal',
    'color': '#414670',
    'margin': '40px 39px'
}

export const VerifyTitleStyle = {
    'fontFamily': 'Lato',
    'fontSize': '24px',
    'fontStretch': 'normal',
    'fontStyle': 'normal',
    'lineHeight': '0.92',
    'letterSpacing': 'normal',
}


export const SubTitleStyle = {
    "width": '360px',
    'fontFamily': 'Lato',
    'fontSize': '16px',
    'fontWeight': 'normal',
    'fontStretch': 'normal',
    'fontStyle': 'normal',
    'lineHeight': '1.93',
    'letterSpacing': 'normal'
}

export {
    VerifyButton, ButtonText, Title, OrContainer, HorizontalLine, ButtonContainer
}